import { FC } from 'react';
import { AsideMenuMain } from './AsideMenuMain';

const AsideMenu: FC = () => {
  return (
    <div className="flex-1 overflow-y-auto overflow-x-hidden sidebar-scroll py-4">
      <AsideMenuMain />
    </div>
  );
};

export { AsideMenu };
